import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function RotaPrivada({ children }) {
  const { usuario, carregando } = useAuth();

  if (carregando) {
    // Aqui você pode retornar um loader visual se quiser
    return null;
  }

  if (!usuario) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
